"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmlsChip = void 0;
const react_1 = __importStar(require("react"));
const className_1 = require("../../utils/className");
exports.SmlsChip = ({ id, className, text = 'Texto', dark = false, disabled = false, onSelect = () => undefined, onRemove = () => undefined, }) => {
    const [isSelected, setIsSelected] = react_1.useState(false);
    react_1.useEffect(() => {
        if (isSelected) {
            onRemove();
        }
        else {
            onSelect();
        }
    }, [isSelected]);
    return (react_1.default.createElement("button", { id: id, type: "button", className: className_1.mapToCssModules([
            className,
            'chip',
            dark ? 'dark' : '',
            isSelected ? 'selected' : '',
        ]), disabled: disabled, onClick: () => setIsSelected((prevState) => !prevState) },
        react_1.default.createElement("span", null, text),
        react_1.default.createElement("i", { className: "material-icons" }, "add"),
        react_1.default.createElement("i", { className: "material-icons" }, "clear")));
};
//# sourceMappingURL=index.js.map